




























helpers = require('../../helpers.coffee')

view_model = {
  components:
    filters: require('./filters.vue')
    businessListItem: require('./list_item.vue')

  props:
    businesses:
      default: -> []

    filters:
      default: -> {}

  data: ->
    selected_business:
      name: "-"

  methods:
    filter: (filters) ->
      @$emit('filter', filters)

    callDestroyBusiness: ->
      @businesses_resource.destroy @destroyBusinessSuccess, @unknownError, id: @selected_business.id

    destroyBusinessSuccess: ->
      @excludeBusinessFromList(@selected_business.id)
      alertify.success this.$t('businesses.feedback.removeSuccess')

    excludeBusinessFromList: (business_id) ->
      index = @businesses.findIndex business_id
      @businesses.splice index, 1 if index > -1
      @selected_business = {name: "-"} # Reset @selected_business value

    openDestroyBusinessModal: (data) ->
      if data.business.contacts_count > 0
        alertify.error this.$t('businesses.label.companyRemoveAlert')
      else
        @selected_business = data.business
        EventsBus.$emit 'confirm-modal-show', id: 'confirm-remove-business'

  created: ->
    @businesses_resource = new BusinessesResource()
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/businesses/list.vue